import React from "react";
import { useSpring, animated } from "@react-spring/web";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa"; // Import quote icons
import "../styles/About.css";

function About() {
  // Define the text content so it can be easily managed
  const title = "About Us";
  const subtitle = "Driving Innovation & Excellence";
  const quote =
    "Innovation is seeing what everybody has seen and thinking what nobody has thought.";
  const quoteAuthor = "– Dr. Albert Szent-Györgyi";
  const whoWeAreText = `We are a dedicated team of professionals committed to providing
              top-tier solutions in our industry. Our expertise spans across
              multiple disciplines, and we pride ourselves on delivering
              high-quality results that exceed expectations. We believe in
              collaboration, continuous learning, and the power of technology
              to transform businesses.`;

  // Animation for the title and subtitle
  const fadeDown = useSpring({
    from: { opacity: 0, transform: "translateY(-30px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { tension: 220, friction: 25 },
    delay: 200,
  });

  // Animation for the quote section
  const fadeUp = useSpring({
    from: { opacity: 0, transform: "translateY(30px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { tension: 200, friction: 30 },
    delay: 500,
  });

  // Animation for the main text content
  const textFade = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 800 },
    delay: 800,
  });

  return (
    <section className="about-section">
      <div className="about-container">
        <animated.div style={fadeDown} className="about-header">
          <h1>{title}</h1>
          <p className="subtitle">{subtitle}</p>
          <div className="header-underline"></div>
        </animated.div>

        <animated.div style={fadeUp} className="about-quote-container">
          <FaQuoteLeft className="quote-icon left" />
          <p className="about-quote">{quote}</p>
          <FaQuoteRight className="quote-icon right" />
          <span className="quote-author">{quoteAuthor}</span>
        </animated.div>

        <animated.div style={textFade} className="about-content">
          <div className="about-text-block box-shadow">
            <h2>Who We Are</h2>
            <p>{whoWeAreText}</p>
          </div>

          {/* New Mission and Vision Section */}
          <div className="about-mission-vision">
            <div className="mission-box box-shadow">
              <h3>Our Mission</h3>
              <p>
                To provide our customers with quality products and services at
                competitive prices, while ensuring that our activities and
                services remain sustainable and environmentally friendly. We aim
                to exceed our customers' expectations by providing exceptional
                service and building long-lasting relationships.
              </p>
            </div>
            <div className="vision-box box-shadow">
              <h3>Our Vision</h3>
              <p>
                To be the leading provider of quality products and services in
                the region, while promoting sustainable and environmentally
                friendly practices. We will achieve this by continuously
                improving our products and services, and by investing in our
                people and technology.
              </p>
            </div>
          </div>

        </animated.div>
      </div>
    </section>
  );
}

export default About;